import React from "react";
import TodayOffers from "../components/TodayOffers";

const BannerPage = () => {
  return (
    <div className="w-full bg-white/80 backdrop-blur py-2 mb-2">
      <TodayOffers limit={10} />
    </div>
  );
};

export default BannerPage;